module.exports = __webpack_public_path__ + "img/mi-message.1ca75ca8.svg";